import React, { useState, useEffect, useMemo } from "react";

export default function EmojiStreak({ game }) {
  const [loading, setLoading] = useState(true);

  const history = game.streakHistory || [];
  
  useEffect(() => {
    if (!game?.loadHistory) return;

    setLoading(true);
    game.loadHistory()
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [game?.loadHistory]);

  const streakDays = (history || []).reduce(
    (max, item) => Math.max(max, Number(item.streakDays) || 0),
    0
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-[85%] max-w-sm rounded-3xl bg-gradient-to-br from-orange-500 via-pink-500 to-violet-600 p-[2px]">
        <div className="rounded-3xl bg-slate-950 p-6 text-center">
          <div className="text-6xl animate-bounce">🔥</div>
          <div className="mt-3 text-2xl font-black text-orange-300">
            Streak Active!
          </div>   
          <div className="mt-2 text-4xl font-black text-white">
            {streakDays} 🔥 Days
          </div>
          <div className="mt-2 text-sm text-slate-300">
            Keep playing daily to grow your brain power 🚀
          </div>
          <div className="mt-4 inline-block px-3 py-1 rounded-full bg-orange-500/20 text-orange-300 text-xs">
            + Bonus XP Unlocked
          </div>
        </div>
      </div>
    </div>
  );
}
